<template>
  <tg-layout
    prefixCls="dashboard"
    :class="{ 'has-detail': showDetail }"
    :style="dynamicStyle"
  >
    <p v-if="hasData">
      <strong>{{ $t("page.dashboard.header.lastUpdate") }}</strong>
      <span>{{ lastUpdateTime }}</span>
      <strong class="ma-l-4">{{
        $t("page.dashboard.header.reciprocal")
      }}</strong>
      <span>
        {{
          $t("page.dashboard.header.reciprocal-time", {
            minute: minute,
            sec: sec,
          })
        }}
      </span>
      <!-- <span class="text-danger-dark">
        {{ $t("page.dashboard.header.notInclude") }}
      </span> -->
    </p>
    <tg-table
      ref="dashboard"
      class="dashboard-table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :header-row-style="{ height: '36px' }"
      :header-cell-style="{ padding: '2px' }"
      :cell-class-name="parseCellClass"
      :row-class-name="rowClassName"
      :fit="true"
      @cell-click="handleCellClick"
      @on-loaded="handleLoaded"
      :tableHeight="500"
      :data-intervalRange="intervalRange"
    >
      <template slot="header.tip" slot-scope="{ column }">
        <div class="dashboard-tip--wrapper">
          <span>{{ $t("column." + column.langKey) }}</span>
          <el-tooltip placement="bottom" effect="dashboard-tip">
            <div slot="content" class="dashboard-tip--content">
              <template
                v-if="$te('page.dashboard-tips.' + column.name + '.descript')"
              >
                <span
                  v-html="
                    $t('page.dashboard-tips.' + column.name + '.descript')
                  "
                ></span>
              </template>
              <template
                v-if="$te('page.dashboard-tips.' + column.name + '.header')"
              >
                <span
                  v-html="$t('page.dashboard-tips.' + column.name + '.header')"
                ></span>
              </template>
            </div>
            <el-avatar :size="14" class="dashboard-avatar">
              <i class="info"></i>
            </el-avatar>
          </el-tooltip>
        </div>
      </template>
      <template slot="intervalText" slot-scope="props">
        <span>{{ $t("component.date.picker." + props.value) }}</span>
      </template>
      <span
        slot="cell"
        slot-scope="props"
        :class="{
          'text-red': props.value < 0,
          'text-green': props.value > 0,
        }"
        >{{ props.formated }}</span
      >
    </tg-table>
    <span
      class="dashboard-header-note text-size-small"
      :class="{
        'text-align-right': !isMobile,
        'text-align-center': isMobile,
      }"
      >{{ $t("page.dashboard.header.note") }}</span
    >

    <detail v-if="showDetail" :options="clickData"></detail>
  </tg-layout>
</template>

<script>
import apis from "@/apis";
import detail from "./detail";
import TgLayout from "@/layout/TgLayout";
import moment from "moment";

import { getAllColumns } from "@/utils/table";
export default {
  name: "dashboard",
  components: {
    detail,
    TgLayout,
  },
  data() {
    return {
      columns: [],
      proxy: apis.dashboard.search,
      showDetail: false,
      clickColumn: null,
      clickOriginColumn: null,
      clickRow: null,
      menuVisible: false,
      lastUpdateTime: null,
      nextUpdateTime: null,
      leftUpdateTime: null,
      hasData: false,
      clickData: {
        column: null,
        row: null,
        col: null,
        isEveryDay: false,
      },
      intervalRange: 7
    };
  },
  created() {
    apis.dashboard.getColumns().then((response) => {
      this.columns = response.data;
      this.$refs.dashboard.init();
    });
    this.setNextUpdateTime();
    this.setLeftUpdateTime();
  },
  mounted() {
    setInterval(() => {
      this.setLeftUpdateTime();
    }, 1000);
  },
  computed: {
    minute() {
      return this.leftUpdateTime ? this.leftUpdateTime.format("mm") : "";
    },
    sec() {
      return this.leftUpdateTime ? this.leftUpdateTime.format("ss") : "";
    },
    locale() {
      return this.$i18n.locale;
    },

    dynamicStyle() {
      if (this.showDetail) {
        return { "min-height": "1100px" };
      }
      return "";
    },
  },
  methods: {
    setNextUpdateTime() {
      this.nextUpdateTime = moment().startOf("hour").add(1, "hours");
    },
    setLeftUpdateTime() {
      let diff = this.nextUpdateTime.diff(moment());
      let duration = moment.duration(diff);
      let durationSecond = moment(duration.asMilliseconds());
      this.leftUpdateTime = durationSecond;
    },
    parseCellClass({ row, column }) {
      if (column.columnKey === "intervalText") {
        let cls = "font-weight-7";
        if (row["time_interval"] >= 3) {
          cls += " clickable";
        }

        return cls;
      }

      const value = row[column.columnKey];
      if (value != 0) {
        return "clickable";
      }

      return "";
    },
    handleCellClick(row, column) {
      const value = row[column.columnKey];
      const isIntervalCol = column.columnKey === "intervalText";
      const isEveryDay = isIntervalCol && row["time_interval"] >= 3;

      // 數量等於 0 或 時間區間定義小於 3(本周)
      if (value == 0 || (isIntervalCol && row["time_interval"] < 3)) {
        return;
      }

      let cols = getAllColumns(this.columns);

      let col = cols.find((x) => x.name == column.columnKey);

      let parent = cols.find((x) => x.name == col.parent);
      col.parent = parent;

      this.clickData = {
        column,
        col,
        row,
        isEveryDay,
      };
      this.clickRow = row;
      this.showDetail = true;
    },
    handleLoaded(response) {
      this.lastUpdateTime = response.update_time;
      this.hasData = !!response.data;
      this.intervalRange = response.data.length;
    },
    rowClassName({ row }) {
      if (!this.clickRow) {
        return;
      }

      if (this.clickRow.intervalText == row.intervalText) {
        return "is-select";
      }
    },
  },
};
</script>
